import { ApiMember } from '../../../../openapi';

export function getMemberDisplayName(member: ApiMember | undefined): string | undefined {
  if (member?.customer.name) {
    return member.customer.name;
  }

  if (member?.individual.name) {
    const { firstName, lastName } = member.individual.name;
    return [firstName, lastName].filter(Boolean).join(' ');
  }

  return undefined;
}

export function getMemberEmail(member: ApiMember | undefined): string | undefined {
  return member?.identity.email ?? member?.identity.unconfirmedEmail ?? undefined;
}
